import React from 'react'
import FreeSubscriptionBlock from '../../FreeSubscriptionBlock'
import PaidSubscriptionBlock from '../../PaidSubscriptionBlock'
import { isPaidSubscription } from '../utils/subscriptionUtils'

const SubscriptionBlockWrapper = ({ type, sub, currentPlan, t }) => {
	const isPaid = isPaidSubscription(type, sub, currentPlan)

	if (isPaid) {
		return (
			<PaidSubscriptionBlock
				type={type}
				sub={sub}
				currentPlan={currentPlan}
				t={t}
			/>
		)
	}

	return (
		<FreeSubscriptionBlock
			type={type}
			sub={sub}
			currentPlan={currentPlan}
			t={t}
		/>
	)
}

export default SubscriptionBlockWrapper

